import posthog from "posthog-js";
import { POSTHOG, isAdminPath, isTrackedHost } from "./posthogConfig.js";

// Page views only. The intranet shows payroll, P&L and bank figures, so there are no session
// recordings and no click capture (a click records the text of what was clicked).
export function startAnalytics() {
  if (!isTrackedHost(window.location.hostname)) return;
  posthog.init(POSTHOG.projectKey, {
    api_host: POSTHOG.apiHost,
    ui_host: POSTHOG.uiHost,
    person_profiles: "identified_only",
    capture_pageview: "history_change", // this app routes by itself, without a router library
    capture_pageleave: true,
    autocapture: false,
    disable_session_recording: true,
    // Everything on an admin-panel address is dropped before it leaves the browser.
    before_send: (event) => (isAdminPath(window.location.pathname) ? null : event),
  });
}
